import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang, getToken } from '../../utils/utils';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect } from 'react';
import { getFunds } from '../../store/actions/fund-action';
import { languages } from '../../config/config';
import { getClientData } from '../../store/actions/investmentsAction';
import { registerFcm } from '../../store/actions/authActions';
import { requestNotificationPermission } from '../../utils/notification_service';
import { getWebDeviceId } from '../../utils/device';

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { investmentContent, language } = useSelector((state) => state.content);
  const { funds, fund_loading } = useSelector((state) => state.fund);
  const { user } = useSelector((state) => state.common);
  const token = getToken()

  useEffect(() => {
    const params = `?LanguageId=${language === languages.eng ? 3 : 4}&isPrivate=${user ? true : false}`;
    dispatch(getFunds(params));
    if (token) {
      dispatch(getClientData());
    }

    if (user) {
      requestNotificationPermission().then((fcmToken) => {
        if (!fcmToken) return;
        dispatch(
          registerFcm({
            clientCode: user?.clientCode,
            fcmToken,
            deviceId: getWebDeviceId(),
            deviceType: 'Web',
          }),
        );
      });
    }
  }, [language, user]);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_fund?.data?.attributes,
      key,
      isArabic,
    );
  };

  return {
    TextWeight,
    getContentKey,
    funds,
    fund_loading,
    direction,
  };
};
